import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const GLOBAL_API_CONFIG = {
  FILE_UPLOAD: {
    endPoint: '/upload',
    method: HTTP_METHODS.POST,
    contentType: 'multipart/form-data',
  },
  BULK_PROMOTION_FILE_UPLOAD: {
    endPoint: '/promotion/bulk-upload',
    method: HTTP_METHODS.POST,
    contentType: 'multipart/form-data',
  },
  UPLOAD_SUGGESTED_SKUS: {
    endPoint: 'suggested-skus/process',
    method: HTTP_METHODS.POST,
    contentType: 'application/json',
    baseUrlKey: 'inventoryApiUrl',
  },
}
